import { isDesktopContext, isFullMode, isZenMode } from 'helpers/desktopApp';
import { isZoomApp } from 'helpers/zoomApp';

import { AnalyticsBrowser } from '@segment/analytics-next';

let platform;

if (isDesktopContext() && isFullMode()) {
  platform = 'desktop full mode';
} else if (isDesktopContext() && isZenMode()) {
  platform = 'desktop zen mode';
} else if (isZoomApp()) {
  platform = 'zoom';
} else {
  platform = 'web';
}

window.initSegment = function (SEGMENT_WRITE_KEY) {
  const analytics = AnalyticsBrowser.load(
    {
      writeKey: SEGMENT_WRITE_KEY
    },
    {
      integrations: {
        'Segment.io': {
          apiHost: 'sega.avoma.com/v1'
        }
      }
    }
  );

  analytics.addSourceMiddleware(({ payload, next }) => {
    if (payload.obj.type === 'track') {
      if (payload.obj.properties) {
        payload.obj.properties.avoma_platform = platform;
      } else {
        payload.obj.properties = {
          avoma_platform: platform
        };
      }
    }
    next(payload);
  });

  window.analytics = analytics;
};
